import Grid from '@material-ui/core/Grid';
import { jsx } from '@emotion/core';
import { withStyles } from '@material-ui/core';
import { Magnetic as Mi } from "../../styles";
const Header = (props) => {
    const { header, headerLightbox, headerCloseButton } = props.classes;
    const closeButton = (jsx("span", { className: `mi-icon-close ${headerCloseButton}`, onClick: props.onClose }));
    return (jsx(Grid, { className: props.isLightbox ? headerLightbox : header, container: true, alignItems: typeof props.title === 'string' ? 'center' : 'stretch', wrap: "nowrap", justify: props.title === '' ? 'flex-end' : 'space-between' },
        props.title,
        !props.hideClose && closeButton));
};
export const ModalHeader = withStyles({
    header: {
        fontSize: Mi.fontSize20,
        fontWeight: Mi.fontWeightSemibold,
        backgroundColor: Mi.colorNeutral02,
        padding: Mi.spacer20,
        flexShrink: 0
    },
    headerLightbox: { fontSize: Mi.fontSize22, padding: Mi.spacer20 },
    headerCloseButton: {
        color: Mi.colorNeutral04,
        cursor: 'pointer',
        fontSize: Mi.fontSize14,
        '&:hover': {
            color: Mi.colorNeutral07
        }
    }
})(Header);
//# sourceMappingURL=ModalHeader.js.map